<template>
  <div style="position: relative">
    <a-icon class="a-icon" type="plus-circle"/>
    <input
        :disabled="disabled"
        class="ant-input"
        type="text"
        readonly
        v-model="text"
        @click="openModal"
    />

    <a-modal forceRender
             v-model="visible"
             :title="title"
             :width="800"
             ok-text="确认"
             cancel-text="取消"
             @ok="handleOk"
             @cancel="handleClose">
      <slot name="childTable"></slot>
    </a-modal>
  </div>

</template>

<script>

// import api from "@/services/api";

export default {
  data() {
    return {
      visible: false,
      childTableRef: '',
    };
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  watch: {
    value: {
      immediate: true,
      handler: function (val) {
        console.log(val)
        // if (val !== this.filePath) {
        //
        // }
      }
    }
  },
  props: {
    value: {
      // 这个参数是v-decorator给子组件传值用的
      // 这里不要给默认值， 在form下使用会爆警告 Warning: SquareUpload `default value` can not collect,  please use `option.initialValue` to set default value.
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openModal() {
      this.childTableRef = this.$slots.childTable[0].data.ref;
      this.visible = true
    },
    handleOk() {
      try {
        this.$emit('select', true, this.childTableRef);
      } catch (e) {
        console.log(e)
      }
      this.visible = false;
    },
    handleClose() {
      this.$emit('select', false, this.childTableRef);
    }
  },
};
</script>
<style scoped>
.a-icon {
  position: absolute;
  z-index: 10;
  right: 6px;
  top: 13px;
  pointer-events: none;
}

input {
  cursor: pointer
}
</style>

